var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKaggleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M398.09 503.141c-.53 1.904-2.539 2.856-5.923 2.856h-65.255a13.14 13.14 0 01-10.576-5.077l-107.77-137.595-29.93 28.661v106.396c.042.307.063.603.063.91 0 3.543-2.908 6.451-6.451 6.451-.307 0-.603-.021-.91-.063h-50.66a6.574 6.574 0 01-.909.063c-3.543 0-6.451-2.908-6.451-6.451 0-.307.02-.603.063-.91V13.362a6.574 6.574 0 01-.063-.91c0-3.542 2.908-6.45 6.451-6.45.307 0 .603.02.91.063h50.659c.307-.043.603-.064.91-.064 3.543 0 6.451 2.909 6.451 6.452 0 .306-.021.602-.063.91V312.03L307.77 181.416a15.247 15.247 0 0110.576-5.182h67.581a5.721 5.721 0 015.817 3.702 6.257 6.257 0 01-.74 6.663l-136.75 131.99L396.61 495.42c2.052 2.01 2.655 5.097 1.48 7.72z",
    fill: "#20beff",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaggleIcon);
export default __webpack_public_path__ + "static/media/kaggle-icon.3569c04f337e67ce5befc8bcf330543d.svg";
export { ForwardRef as ReactComponent };